import "./CAV.css"
import {Row,Col,Card, Container} from "react-bootstrap"
import {Link} from "react-router-dom"
const CAV = () =>{
    return <div style={{padding:"2%"}}>   
    <h1>CAV</h1>
    <ul className="flex-container">
    <li className = "flex-item" style={{width:"40rem"}}>

    <p>CAV is a utility module capable of performing most of your essential tasks in one package. 
      </p>
      <p>It contains 2 units. One unit can:</p>
      <ul>
          <li>Crossfade</li>
          <li>Attenuvert</li>
          <li>Attenuate</li>
          <li>Bipolar Voltage Source</li>
      </ul>
      <br></br>
      <p>The module contains 2 of these units chained together, with a 3rd output which sums the outputs together. This expands the possibilities greatly! to name a few:</p>
      <ul>
          <li>Modulate and DC Offset</li>
          <li>Mix 2 signals</li>
          <li>Evenly cross mix 3 signals with 2 sliders</li>
          <li>Combine 4 signals in a weird way</li>
          <li>Subtract signals: convert LP to HP, or phase subtractive synthesis </li>
          <li>Mono to stereo convertor w/ panning and phase inversion</li>
          <li>Amplify a signal up to 2x by adding to itself</li>
      </ul>
        <br/>
      <br/>
      <div>
      <h2>Details</h2>
      <p>2 Active Manual Crossfader Units</p>
      <p>6HP</p>
      <p>Accepts AC and DC input</p>
      <p>Active with protective output buffers</p>
      <p>2 LED sliders with 45mm travel for tactile and precise control</p>
      </div>
      
      <h2>How to Use</h2>
      <p>A unit has 2 inputs, top and bottom: labelled <b>A</b> & <b>B</b> and <b>C</b> & <b>D</b>. A unit linearly crossfades between these inputs</p>
      <p>When nothing is inserted into B, it is noirmalled to the inverse of A - creating an attenuverter when only A is used. Plug a hanging cable into B for an attenuator</p>
      <p>When nothing is inserted into A, it is normalled to a 5V reference. This creates a bipolar +- 5V voltage source when nothing is inserted. Plug a hanging cable into B for a precice 0-5V</p>      
      <p>To enable parallel processing A is normalled to C</p>
      <p>An output in the middle sums the outputs of both unit</p>

      <h2>Some extra details</h2>
      <p>As my first run at mass producing PCBs at a fab house I had some teething issues and mistakes that will never happen again.</p>
      <p>
        The First run of DIY modules (V3.3) had a bug on the board which limited the range of the voltage source to +-2.5V. Those who purchased were aware.
      </p>
      <p>
        The Second run of Modules (V3.4) and V3.3 have a small issue where the LEDs cause asymetrical clipping. You can fix this by either: using a blue LED (limits usable range to just past 5V), Remove the LED, or embrace it and make it bipolar 
      </p>
      
      <p>
        The module is active and provides all the benefits that come with that. The output buffers include protection against accidental grounding and prevents drooping when connected directly to multiple inputs!
      </p>
      <p>Their are some light behavioural customisation options for advanced usage, this page and build guide assume the recommended setup.</p>
      <p>All outputs and some inputs have exposed pins for connecting to other modules with this feature to create some semi-modualar experience.</p>

      <h2>DIY</h2>
      <p>CAV comes SMD pre-soldered, The instructions to finish it are in the <Link to = "/CAV/build">Build Guide</Link>
  </p>

      <table>
        <tr>
        <th>Name</th>
        <th>Quantity  
        </th>
        <th>Mandatory
        </th>
        </tr>
        <tr>
          <td>Mono 3.5mm Jacks (thonkiconn)</td>
          <td>7</td>
          <td>Yes</td>
        </tr>
        <tr>
          <td>shrouded 2x5 pin header</td>
          <td>
            1
          </td>
          <td>
            Yes
          </td>
         
        </tr>
        <tr>
          <td>
              PTL45: 45mm LED slider
          </td>
          <td>
            2
          </td>
          <td>
            Yes
          </td>
          
        </tr>
        <tr>
          <td>M2 Screws</td>
          <td>4</td>
          <td>Yes</td>
        
        </tr>
        <tr>          
          <td>M2 spacers</td>
          <td>4</td>
          <td>No</td>

        </tr>
        <tr>
          <td>2.54mm box pin headers</td>
          <td>11</td>
          <td>No</td>
          
        </tr>
        <tr>
        <td>1x2 2.54mm header jumpers </td>
        <td>3</td>
        <td>No</td>
        
        </tr>
        <tr>
          <td>
          Ferrite bead
          </td>
          <td>2</td>
          <td>No</td>
        
        </tr>
      </table>
          <br></br>
          <h2>Links</h2>
          <h3><Link to = "/CAV/build">Build Guide</Link></h3>
          <h3><a href = "/CAV_ibom.html">BOM</a></h3>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
    </li>

      <li className = "flex-item" style={{width:"30rem"}}>
        <img src={require("./NewCAVPanels.jpg")} style={{width:"100%"}}></img>
        <p>NEW MORE DESCRIPTIVE PANELS!</p>
      </li>
    </ul>

    </div>
}

export default CAV